/**
 * Standard API Response Types
 */

export interface ApiSuccessResponse<T = unknown> {
    data?: T;
    message?: string;
}

export interface ApiErrorResponse {
    error: string;
    message?: string;
}

export type ApiResponse<T = unknown> = ApiSuccessResponse<T> | ApiErrorResponse;

/**
 * Type guard to check if response is an error
 */
export function isApiError(response: ApiResponse): response is ApiErrorResponse {
    return 'error' in response;
}

/**
 * Type guard to check if response has data
 */
export function hasData<T>(response: ApiResponse<T>): response is ApiSuccessResponse<T> & { data: T } {
    return 'data' in response && response.data !== undefined;
}

